export default function () {
  const widgetName = 'headerButtonWidget';
  const widgetOpts = headerButtonWidgetOpts;
  const $widgetHTML = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($widgetHTML, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: true,
    cardWidgetLoaded: function (data, _owl, hasData) {
      const { URL, PurchaseURL } = data.items[0];
      const links = PurchaseURL || URL;
      if (!hasData || !links) {
        $widgetHTML.remove();
      }
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: ['all'],
    maxItemsVisible: 1,
    moreButton: false,
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true,
  });
}
